<template>
	<div class="fcs-bracket-challenge-home-page">
		<div class="fcs-bracket-challenge-home-page__content">
			<div class="pool-data" v-if="pool != null">
				<h3 class="header">{{ pool.name }}</h3>
				<router-link class="pool-data--manage-brackets" :to="{ name: 'fcs-bracket-challenge-manage-brackets', params: { poolId: pool.id, entryId:  userEntryId} }" v-if="!pool.playoff.underway">Manage Brackets</router-link>
				<table class="brackets-table">
					<tr class="brackets-table--header">
						<th class="standings-column"></th>
						<th class="bracket-column">Bracket</th>
						<th>Score</th>
						<th>Possible</th>
					</tr>
					<tr class="brackets-table--bracket" v-for="(bracket, index) in brackets" :key="index">
						<td class="standings-column">{{ index + 1 }}</td>
						<td class="bracket-column" v-if="!pool.playoff.underway">{{ bracket.name }}</td>
						<td class="bracket-column" v-else><router-link class="bracket-link" :to="{ name: 'fcs-bracket-challenge-bracket-result', params: { poolId: pool.id, entryId: bracket.entry_id, bracketId: bracket.id } }">{{ bracket.name }}</router-link></td>
						<td class="score-column">{{ bracket.score }}</td>
						<td class="possible-column">{{ bracket.possible }}</td>
					</tr>
				</table>
			</div>	
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapGetters } from 'vuex'
	import axios from '@/axios'
	
	export default {
		props: ['poolId'],
		data() {
			return  {
				pool: null
			}
		},
		computed: {
			...mapGetters([
				'authenticated'
			]),
			brackets() {
				var brackets = []
				if ("entries" in this.pool) {
					this.pool.entries.forEach(function(element) {
						element.brackets.forEach(function(el) {
							brackets.push(el)
						})
					})
				}

				brackets.sort(function(a, b) {
					if(a.score == b.score) {
						return b.possible - a.possible
					} else {
						return b.score - a.score
					}
				})

				return brackets
			},
			userEntryId() {
				var id = 0
				if("entries" in this.pool) {
					this.pool.entries.forEach(function(element) {
						if(element.current_user_entry) {
							id = element.id
						}
					})
				}

				return id
			},
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			getBracketChallenge() {
				return axios.get('fcs-bracket-challenges/' + this.poolId)
			}
		},
		created() {
			this.HTTP_IN_PROGRESS()
			this.getBracketChallenge().then(response => {
					this.pool = response.data.data
					this.HTTP_FINISHED()
				}).catch(() => {
					this.$router.replace('/')
				})
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/fcs/fcs-bracket-challenge/home';
</style>